module.exports = ".header {\n  line-height: 0; }\n"